import { AppContext } from '../../../../context';
import { useContext } from 'react';

interface HeaderCardProps {
    forText: string;
    guest?: {
        fullName: string;
        givenName: string;
        familyName: string;
        profileUrl: string;
        email: string;
    } | null;
}

const firstLetter = (name: string) => {
    return name.charAt(0).toUpperCase();
};

const displayName = (fullName: string | null, givenName: string, familyName: string): string => {
    let name = fullName;
    if (!name) {
        name = `${givenName ?? ''} ${familyName ?? ''}`;
    }
    return name;
};

const HeaderCard: React.FC<HeaderCardProps> = ({ guest, forText }) => {
    const { translate } = useContext(AppContext);
    const fullName = displayName(guest?.fullName ?? '', guest?.givenName ?? '', guest?.fullName ?? '');
    return (
        <div className="bigFlexHeader">
            {guest?.profileUrl ? (
                <img src={guest.profileUrl} className="bigFlexCardInterviewerImage" alt="" />
            ) : (
                <div className="roundedImgPlaceholder flex">{firstLetter(fullName)}</div>
            )}
            <div className="flexCardBodyLeftInterviewer">
                <span className="flexCardBodyLeftInterviewerName">{fullName}</span>
                <span className="flexCardBodyLeftInterviewerDescription">
                    {translate('candidatePortal:for')}
                    <strong>
                        {' '}
                        {forText
                            .split(' ')
                            .map((w: string) => w.charAt(0).toUpperCase() + w.slice(1))
                            .join(' ')}
                    </strong>
                </span>
            </div>
        </div>
    );
};

export default HeaderCard;
